import {inject, Injectable} from '@angular/core';
import {DirectusService, HrToolMini} from '@frontend/directus';
import {firstValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class HrToolsMiniProviderService {
  private readonly directusService = inject(DirectusService);

  private _hrToolsMini: HrToolMini[] | undefined = undefined;

  async getHrTools(): Promise<HrToolMini[]> {
    if (this._hrToolsMini) {
      return this._hrToolsMini;
    }
    this._hrToolsMini = await firstValueFrom(this.directusService.loadHrToolsMini());
    return this._hrToolsMini;
  }
}
